export class GetDeviceInfoAction {
    constructor() {
        this.name = 'GetDeviceInfo';
        this.isDeviceAction = true;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2V0RGV2aWNlSW5mb0FjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWxzL2FjdGlvbnMvR2V0RGV2aWNlSW5mb0FjdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPQSxNQUFNLE9BQU8sbUJBQW1CO0lBQWhDO1FBQ2tCLFNBQUksR0FBRyxlQUFlLENBQUM7UUFDdkIsbUJBQWMsR0FBRyxJQUFJLENBQUM7SUFDeEMsQ0FBQztDQUFBIn0=